<script setup>
import {reactive, computed, onMounted} from 'vue';
import JsonCSV from 'vue-json-csv';
import mapboxgl from "mapbox-gl";
import user from "./user.png";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import CreateUserFromPersonComponent from "@/Components/UserManagement/CreateUserFromPersonComponent.vue";
import {ToastUtil} from "@/Utils/ToastUtil";
import {DateUtil} from "@/Utils/DateUtil";

const data = reactive({
  personId: 0,
  dialogStatus: 'closed',
  stateItems: [ 'AL', 'AK', 'AS', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FM', 'FL', 'GA', 'GU', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MH', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'MP', 'OH', 'OK', 'OR', 'PW', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VI', 'VA', 'WA', 'WV', 'WI', 'WY' ],
  people: [],
  losslocationModel: null,
  statusModel: null,
  firstcallModel: null,
  hasAccountModel: null,
  certificationItems: [],
  geodata: [],
  lat: null,
  long: null,
  preferredModel: null,
  catactiveModel: null,
  trainerModel: null,
  nameModel: null,
  date: null,
  npn: null,
  npnDateStart: null,
  npnDateEnd: null,
  npnStartOpen: false,
  npnEndOpen: false,
  licensestateModel: null,
  stateModel: null,
  deployedstateModel: null,
  trainerItems: [],
  filterArr: [],
  clustering: false,
  dataLoading: false,
  firstLoad: true,
  items: [],
  labels: {
  },
  prevOptions: {},
  loading: false,
  map: null,
  mapMarkers: [],
  certifications: [],
  newUrl: '',

  options: {
    sortBy: [{key: '', order: 'desc'}],
    page: 1,
    itemsPerPage: 1000
  },

  search: '',
  searchRefresh: '',
  searchRequest: null,
  showMap: false,
  totalPeople: 0,
  timezone: new Date(),
  headers: [],
  popupHeaders: [
    {
      title: 'Person Name',
      key: 'name',
      bool: true,
    },
    {
      title: 'Legal Name',
      key: 'name',
      bool: false,
    },
    {
      title: 'Home Phone',
      key: 'homephone',
      bool: false,
    },

    {
      title: 'Mobile Phone',
      key: 'mobilephone',
      bool: true,
    },
    {
      title: 'Work Phone',
      key: 'workphone',
      bool: false,
    },
    {
      title: 'Email',
      key: 'email',
      bool: true,
    },
    {
      title: 'Birth Date',
      key: 'dob',
      bool: false,
    },
    {
      title: 'Status',
      key: 'status',
      bool: true,
    },
    {
      title: 'First Call',
      key: 'firstcall',
      bool: false,
    },
    {
      title: 'Preferred',
      key: 'preferred',
      bool: false,
    },
    {
      title: 'Cat. Active',
      key: 'catactive',
      bool: false,
    },
    {
      title: 'Street Address',
      key: 'streetaddress',
      bool: false,
    },
    {
      title: 'City',
      key: 'city',
      bool: false,
    },
    {
      title: 'State',
      key: 'state',
      bool: false,
    },
    {
      title: 'Zip',
      key: 'zip',
      bool: false,
    },
    {
      title: 'Deployed Street',
      key: 'deployedstreetaddress',
      bool: false,
    },{
      title: 'Deployed State',
      key: 'deployedstate',
      bool: false,
    },
    {
      title: 'Deployed City',
      key: 'deployedcity',
      bool: false,
    },
    {
      title: 'Deployed Zip',
      key: 'deployedzip',
      bool: false,
    },
    {
      title: 'Current Claims',
      key: 'curclaims',
      bool: true,
    },
    {
      title: 'Claim Limit',
      key: 'claim_limit',
      bool: true,
    },
    {
      title: 'Open As Adjuster',
      key: 'openadjuster',
      bool: false,
    },
    {
      title: 'Open As Reviewer',
      key: 'openreviewer',
      bool: false,
    },
    {
      title: 'Open As Acct. Mgr.',
      key: 'openmanager',
      bool: false,
    },
    {
      title: 'Total Claims',
      key: 'totalworked',
      bool: false,
    },
    {
      title: 'Claims Last 2 Years',
      key: 'totalworked2years',
      bool: true,
    },
    {
      title: 'Training Fee',
      key: 'training_fee',
      bool: false,
    },
    {
      title: 'Trainer',
      key: 'trainer',
      bool: false,
    },
    {
      title: 'Short Comment',
      key: 'shortcomment',
      bool: true,
    },
    {
      title: 'NPN',
      key: 'npn',
      bool: true,
    },
    {
      title: 'NPN Updated',
      key: 'npn_updated_on',
      bool: true,
    },
    {
      title: 'Distance From Loss(Flight - Miles)',
      key: 'distance',
      bool: false,
    },
    {
      title: 'Roles',
      key: 'roles',
      bool: false,
    },
    {
      title: 'User Account',
      key: 'hasaccount',
      bool: false
    }
  ],
  defaultHeaders: [
    {
      title: 'Person Name',
      key: 'name',
      bool: true,
    },
    {
      title: 'Legal Name',
      key: 'legalname',
      bool: true,
    },
    {
      title: 'Home Phone',
      key: 'homephone',
      bool: true,
    },

    {
      title: 'Mobile Phone',
      key: 'mobilephone',
      bool: true,
    },
    {
      title: 'Work Phone',
      key: 'workphone',
      bool: true,
    },
    {
      title: 'Email',
      key: 'email',
      bool: true,
    },
    {
      title: 'Birth Date',
      key: 'dob',
      bool: true,
    },
    {
      title: 'Status',
      key: 'status',
      bool: true,
    },
    {
      title: 'First Call',
      key: 'firstcall',
      bool: true,
    },
    {
      title: 'Preferred',
      key: 'preferred',
      bool: true,
    },
    {
      title: 'Cat. Active',
      key: 'catactive',
      bool: true,
    },
    {
      title: 'Street Address',
      key: 'streetaddress',
      bool: true,
    },
    {
      title: 'City',
      key: 'city',
      bool: true,
    },
    {
      title: 'State',
      key: 'state',
      bool: true,
    },
    {
      title: 'Zip',
      key: 'zip',
      bool: true,
    },
    {
      title: 'Deployed Street',
      key: 'deployedstreetaddress',
      bool: true,
    },{
      title: 'Deployed State',
      key: 'deployedstate',
      bool: true,
    },
    {
      title: 'Deployed City',
      key: 'deployedcity',
      bool: true,
    },
    {
      title: 'Deployed Zip',
      key: 'deployedzip',
      bool: true,
    },
    {
      title: 'Current Claims',
      key: 'curclaims',
      bool: true,
    },
    {
      title: 'Claim Limit',
      key: 'claim_limit',
      bool: true,
    },
    {
      title: 'Open As Adjuster',
      key: 'openadjuster',
      bool: true,
    },
    {
      title: 'Open As Reviewer',
      key: 'openreviewer',
      bool: true,
    },
    {
      title: 'Open As Acct. Mgr.',
      key: 'openmanager',
      bool: true,
    },
    {
      title: 'Total Claims',
      key: 'totalworked',
      bool: true,
    },
    {
      title: 'Claims Last 2 Years',
      key: 'totalworked2years',
      bool: true,
    },
    {
      title: 'Training Fee',
      key: 'training_fee',
      bool: true,
    },
    {
      title: 'Trainer',
      key: 'trainer',
      bool: true,
    },
    {
      title: 'Short Comment',
      key: 'shortcomment',
      bool: true,
    },
    {
      title: 'NPN',
      key: 'npn',
      bool: true,
    },
    {
      title: 'NPN Updated',
      key: 'npn_updated_on',
      bool: true,
    },
    {
      title: 'Distance From Loss(Flight - Miles)',
      key: 'distance',
      bool: true,
    },
    {
      title: 'Roles',
      key: 'roles',
      bool: true,
    },
    {
      title: 'User Account',
      key: 'hasaccount',
      bool: true
    }
  ],
});

const headers = computed(()=>{
  return [
    {
      title: 'Person Name',
      key: 'name',
      bool: true,
    },
    {
      title: 'Legal Name',
      key: 'legalname',
      bool: true,
    },
    {
      title: 'Home Phone',
      key: 'homephone',
      bool: true,
    },

    {
      title: 'Mobile Phone',
      key: 'mobilephone',
      bool: true,
    },
    {
      title: 'Work Phone',
      key: 'workphone',
      bool: true,
    },
    {
      title: 'Email',
      key: 'email',
      bool: true,
    },
    {
      title: 'Birth Date',
      key: 'dob',
      bool: true,
    },
    {
      title: 'Status',
      key: 'status',
      bool: true,
    },
    {
      title: 'First Call',
      key: 'firstcall',
      bool: true,
    },
    {
      title: 'Preferred',
      key: 'preferred',
      bool: true,
    },
    {
      title: 'Cat. Active',
      key: 'catactive',
      bool: true,
    },
    {
      title: 'Street Address',
      key: 'streetaddress',
      bool: true,
    },
    {
      title: 'City',
      key: 'city',
      bool: true,
    },
    {
      title: 'State',
      key: 'state',
      bool: true,
    },
    {
      title: 'Zip',
      key: 'zip',
      bool: true,
    },
    {
      title: 'Deployed Street',
      key: 'deployedstreetaddress',
      bool: true,
    },{
      title: 'Deployed State',
      key: 'deployedstate',
      bool: true,
    },
    {
      title: 'Deployed City',
      key: 'deployedcity',
      bool: true,
    },
    {
      title: 'Deployed Zip',
      key: 'deployedzip',
      bool: true,
    },
    {
      title: 'Current Claims',
      key: 'curclaims',
      bool: true,
    },
    {
      title: 'Claim Limit',
      key: 'claim_limit',
      bool: true,
    },
    {
      title: 'Open As Adjuster',
      key: 'openadjuster',
      bool: true,
    },
    {
      title: 'Open As Reviewer',
      key: 'openreviewer',
      bool: true,
    },
    {
      title: 'Open As Acct. Mgr.',
      key: 'openmanager',
      bool: true,
    },
    {
      title: 'Total Claims',
      key: 'totalworked',
      bool: true,
    },
    {
      title: 'Claims Last 2 Years',
      key: 'totalworked2years',
      bool: true,
    },
    {
      title: 'Training Fee',
      key: 'training_fee',
      bool: true,
    },
    {
      title: 'Trainer',
      key: 'trainer',
      bool: true,
    },
    {
      title: 'Short Comment',
      key: 'shortcomment',
      bool: true,
    },
    {
      title: 'NPN',
      key: 'npn',
      bool: true,
    },
    {
      title: 'NPN Updated',
      key: 'npn_updated_on',
      bool: true,
    },
    {
      title: 'Distance From Loss',
      key: 'distance',
      bool: true,
    },
    {
      title: 'Roles',
      key: 'roles',
      bool: true,
    },
    {
      title: 'User Account',
      key: 'hasaccount',
      bool: true
    }
  ]
});

const getHeaderFields = () => {
  let headerArr = []
  for(let x in data.headers){
    if(data.headers[x].align !== ' d-none'){
      headerArr.push(data.headers[x].key)
    }
  }
  return headerArr
}

const formatDate = (date) => {
  if (!date) return null
  const [year, month, day] = date.split('-')
  return `${month}/${day}/${year}`
}

const getTimezone = (timezoneShortened) => {
  const tzName = data.timezone
  return tzName.toLocaleString('en', {timeZoneName:'short'}).split(' ').pop();
}

const refresh = ({page, itemsPerPage, sortBy, nomap}) => {
  data.dataLoading = true

  if(data.losslocationModel !== null){
    let encodedSearch = encodeURI(data.losslocationModel.replace('#', ''))
    ApiWrapper.getRaw(
          'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
          encodedSearch +
          '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
    )
    .then(function (response) {
      let lat = null
      let long = null
      let center = null
      if(response.features.length > 0){
        lat = response.features[0].center[1]
        long = response.features[0].center[0]
        center = response.features[0].center
      }
      data.lat = lat
      data.long = long

      ApiWrapper.post('person', 'filter-people-new', {
            lossLat: lat,
            lossLong: long,
            status: data.statusModel,
            state: data.stateModel,
            deployedstate: data.deployedstateModel,
            trainer: data.trainerModel,
            license: data.licensestateModel,
            certifications: data.certifications,
            name: data.nameModel,
            npn: data.npn,
            npndatestart: data.npnDateStart,
            npndateend: data.npnDateEnd,
            catactive: data.catactiveModel,
            preferred: data.preferredModel,
            firstcall: data.firstcallModel,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy?.length > 0 ? sortBy[0].key : '',
            sortDesc: sortBy?.length > 0 ? sortBy[0].order : 'desc',
            page: page,
            hasAccount: data.hasAccountModel
          })
          .then((response) => {
            data.people = response.data
            data.items = data.people
            data.geodata = response.geodata
            let total = response.total

            data.totalPeople = (total * 1)
            data.map.flyTo({
              center: center,
              zoom: 5,
              essential: true, // this animation is considered essential with respect to prefers-reduced-motion
            })
            if (nomap !== true) {
              createMapMarkers(response.geodata, 'people')
            }
          })
          .catch((e)=>{
            ToastUtil.error(e);
          })
          .finally(()=>{
            data.prevOptions.page = page;
            data.prevOptions.itemsPerPage = itemsPerPage;
            data.prevOptions.sortBy = sortBy ? JSON.parse(JSON.stringify(sortBy)) : sortBy;

            data.loading = false
            data.dataLoading = false
          })
    })
    .catch((err) => {
      ToastUtil.error(err);
      data.dataLoading = false;
    })
  }else{
    ApiWrapper.post('person', 'filter-people-new', {
          lossLat: null,
          lossLong: null,
          status: data.statusModel,
          state: data.stateModel,
          deployedstate: data.deployedstateModel,
          trainer: data.trainerModel,
          license: data.licensestateModel,
          certifications: data.certifications,
          name: data.nameModel,
          npn: data.npn,
          npndatestart: data.npnDateStart,
          npndateend: data.npnDateEnd,
          catactive: data.catactiveModel,
          preferred: data.preferredModel,
          firstcall: data.firstcallModel,
          itemsPerPage: itemsPerPage,
          sortBy: sortBy?.length > 0 ? sortBy[0].key : '',
          sortDesc: sortBy?.length > 0 ? sortBy[0].order : 'desc',
          page: page,
          hasAccount: data.hasAccountModel
        })
        .then((response) => {
          data.people = response.data

          data.items = data.people
          let total = response.total
          data.geodata = response.geodata

          data.totalPeople = (total * 1)
          if (nomap !== true) {
            createMapMarkers(response.geodata, 'people')
          }
        })
        .catch((e)=>{
          ToastUtil.error(e);
        })
        .finally(()=>{
          data.prevOptions.page = page;
          data.prevOptions.itemsPerPage = itemsPerPage;
          data.prevOptions.sortBy = sortBy ? JSON.parse(JSON.stringify(sortBy)) : sortBy;

          data.loading = false
          data.dataLoading = false
        })
  }

}

const hideMap = (bool) => {
  if(!bool){
    document.getElementById('map').style.visibility = 'hidden';
    document.getElementById('map').style.height = '0px';

  }else{
    document.getElementById('map').style.visibility = 'visible';
    document.getElementById('map').style.height = '500px';

  }
}

const changeHeaders = () => {
  data.headers = headers.value;

  for (let x in data.defaultHeaders) {
    if (data.defaultHeaders[x].bool === false) {
      if(data.headers[x]){
        data.headers[x].align = ' d-none'
      }
    } else {
      if(data.headers[x]){
        data.headers[x].align = ''
      }
    }
  }
  localStorage.setItem('headersPeople', JSON.stringify(data.defaultHeaders))
  localStorage.setItem('versionPeople', 1)

  localStorage.setItem('headersPeopleMap', JSON.stringify(data.popupHeaders))
  localStorage.setItem('versionPeopleMap', 1)

  data.searchRefresh = ' '
  setTimeout(() => {
    data.searchRefresh = ''
  }, 10)
}

const searchMap = () => {
  let encodedSearch = encodeURI(data.searchRequest.replace('#', ''))
  let map = data.map
  // ApiWrapper({
  //   method: 'get',
  //   url:
  //       'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
  //       encodedSearch +
  //       '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ',
  // }).then(function (response) {
  //   map.flyTo({
  //     center: response.features[0].center,
  //     zoom: 9,
  //     essential: true, // this animation is considered essential with respect to prefers-reduced-motion
  //   })
  // })
}

const getData = () => {
  data.dataLoading = true
  ApiWrapper.post('person', 'person-search-init', {})
      .then((response) => {
        if(response.trainers){
          data.trainerItems = response.trainers.map((trainer) => {
            trainer.title = trainer.trainer;
            trainer.value = trainer.trainer;
            return trainer;
          })
        }
        if(response.certifications){
          data.certificationItems = response.certifications.map((cert) => {
            cert.title = cert.text;
            return cert;
          })
        }
        changeHeaders()
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
}

const createMapMarkers = (geodata, type) => {
  if (data.firstLoad === false) {
    data.map.removeLayer('clusters')
    data.map.removeLayer('cluster-count')
    data.map.removeLayer('unclustered-point')
    data.map.removeSource('notype')
  } else {
    data.firstLoad = false
  }

  data.map.addSource('notype', {
    type: 'geojson',
    // // Point to GeoJSON data. This example visualizes all M1.0+ earthquakes
    // // from 12/22/15 to 1/21/16 as logged by USGS' Earthquake hazards program.
    data: geodata,
    cluster: data.clustering,
    clusterMaxZoom: 14, // Malet x zoom to cluster points on
    clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
  })

  data.map.addLayer({
    id: 'clusters',
    type: 'circle',
    source: 'notype',
    filter: ['has', 'point_count'],
    paint: {
      // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
      // with three steps to implement three types of circles:
      //   * Blue, 20plet x circles when point count is less than 100
      //   * Yellow, 30plet x circles when point count is between 100 and 750
      //   * Pink, 40plet x circles when point count is greater than or equal to 750
      'circle-color': [
        'step',
        ['get', 'point_count'],
        '#51bbd6',
        100,
        '#f1f075',
        750,
        '#f28cb1',
      ],
      'circle-radius': [
        'step',
        ['get', 'point_count'],
        20,
        100,
        30,
        750,
        40,
      ],
    },
  })

  data.map.addLayer({
    id: 'cluster-count',
    type: 'symbol',
    source: 'notype',
    filter: ['has', 'point_count'],
    layout: {
      'text-field': '{point_count_abbreviated}',
      'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
      'text-size': 12,
    },
  })

  data.map.addLayer({
    id: 'unclustered-point',
    source: 'notype',
    type: 'symbol',
    filter: ['!', ['has', 'point_count']],
    layout: {
      'icon-image': user,
      'icon-size': 0.75,
      'icon-allow-overlap': true,
    },
  })

  // inspect a cluster on click
  data.map.on('click', 'clusters', function (e) {
    let features = data.map.queryRenderedFeatures(e.point, {
      layers: ['clusters'],
    })
    let clusterId = features[0].properties.cluster_id
    data.map
        .getSource('notype')
        .getClusterExpansionZoom(clusterId, function (err, zoom) {
          if (err) return

          data.map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom,
          })
        })
  })

  // When a click event occurs on a feature in
  // the unclustered-point layer, open a popup at
  // the location of the feature, with
  // description HTML from its properties.
  data.map.on('click', 'unclustered-point', function (e) {
    // if (data.popup !== '') {
    //   data.popup.remove()
    // }
    let stackedPeople = []
    for (let x in e.features) {

      let newPeople = e.features[x].properties
      stackedPeople.push(newPeople)
    }

    let coordinates = e.features[0].geometry.coordinates.slice()

    // Ensure that if thedata.map is zoomed out such that
    // multiple copies of the feature are visible, the
    // popup appears over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360
    }

    let htmlString = ''
    for (let y = 0; y < stackedPeople.length; y++) {
      if (stackedPeople.length > 1) {
        htmlString += `<div style="border-bottom: 1px solid black;width: 400px;height:100%">`
      } else {
        htmlString += `<div style="width: 400px;height:100%">`
      }

      let col = 0

      for(let x in data.popupHeaders){
        let curHeader = data.popupHeaders[x]
        if(curHeader.bool === true){
          if(col === 1){
            htmlString += `  <div class="column" style="width: 200px; text-align: left; padding-left: 20px;">`
          }
          if(col === 0){
            htmlString += `
                      <div class="row">
                        <div class="column" style="width: 200px; text-align: left; padding-left: 20px;">
                      `
          }

          const value = stackedPeople[y][curHeader.key];
          const outputValue = (value !== 'null' && value !== null && value !== 'undefined' && value !== undefined ? value : '--');

          htmlString += `<span>` + curHeader.title + `:<span></br><h3> ` + outputValue + `</h3>`
          htmlString += `</div>`
          if(col === 1){
            htmlString += `</div>`
            col = 0
          }else{
            col = 1
          }
        }
      }


      htmlString += `       </div>`
    }

    data.popup = new mapboxgl.Popup()
        .setLngLat(coordinates)
        .setHTML(htmlString)
        .addTo(data.map)
  })

  data.map.on('mouseenter', 'clusters', function () {
    data.map.getCanvas().style.cursor = 'pointer'
  })
  data.map.on('mouseleave', 'clusters', function () {
    data.map.getCanvas().style.cursor = ''
  })

  data.loading = false
}

// Clear out the new user data
const clearData = () => {
  data.temporaryPassword = '';
  data.createAccount = false;
  data.roles = [];
  data.permissions = [];
}

const createUserFromPerson = (item) => {
  data.dialogStatus = 'open';
  data.personId = item.id;
}

onMounted(()=>{
  if(localStorage.getItem('versionPeople') === '1'){
    if(localStorage.getItem('headersPeople') !== null){
      data.defaultHeaders = JSON.parse(localStorage.getItem('headersPeople'))
    }
  }
  if(localStorage.getItem('versionPeopleMap') === '1'){
    if(localStorage.getItem('headersPeopleMap') !== null){
      data.popupHeaders = JSON.parse(localStorage.getItem('headersPeopleMap'))
    }
  }

  document.getElementById('map').style.visibility = 'hidden';
  document.getElementById('map').style.height = '0px';

  // this.FilterPeople();

  mapboxgl.accessToken =
      'pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'

  data.map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [-99.121313, 39.816975 ],
    zoom: 3,
  })

  data.map.on('load', function () {
    data.map.loadImage(user, function (error, image) {
      if (error) throw error
      data.map.addImage(user, image)
      getData()
    })
  })
})

const updateSortBy = (sortBy) => {
  if(JSON.stringify(sortBy) !== JSON.stringify(data.prevOptions?.sortBy)) {
    data.options.sortBy = sortBy;

    refresh({
      page: data.options.page,
      itemsPerPage: data.options.itemsPerPage,
      sortBy: sortBy
    });
  }
}

const updateItemsPerPage = (itemsPerPage) => {
  if(itemsPerPage !== data.prevOptions?.itemsPerPage){
    data.options.itemsPerPage = itemsPerPage;

    refresh({
      page: data.options.page,
      itemsPerPage: itemsPerPage,
      sortBy: data.options.sortBy
    });
  }
}

const updatePage = (page) => {
  if(page !== data.prevOptions?.page){
    data.options.page = page;

    refresh({
      page: page,
      itemsPerPage: data.options.itemsPerPage,
      sortBy: data.options.sortBy
    });
  }
}

const parseDateWithTZ = (dateStr) => {
  if (!dateStr) return null;
  dateStr = dateStr.split('T')[0];
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(year, month - 1, day);
}

const displayTzDate = (dateStr) => {
  const date = parseDateWithTZ(dateStr);
  return date ? date.toLocaleDateString() : null;
}

</script>

<template>
  <v-container fluid>
    <CreateUserFromPersonComponent :personId="data.personId" :status="data.dialogStatus" @closed="data.dialogStatus='closed'" @newUser="refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })"/>
    <v-card class="elevation-2">
      <v-toolbar flat color="white">
        <v-toolbar-title>People</v-toolbar-title>
        <div class="px-2">
          <v-btn size="small" @click="refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })" variant="elevated" color="primary">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>

        <JsonCSV
            :data="data.people"
            :fields="getHeaderFields()"
            name="Search People.csv"
            :labels="data.labels"
        >
          <v-btn size="small" variant="elevated" color="primary">
            <v-icon> mdi-file-download </v-icon>
          </v-btn>
        </JsonCSV>

        <v-progress-linear
            :active="data.loading"
            :indeterminate="data.loading"
            absolute
            bottom
            color="primary"
        >
        </v-progress-linear>

        <v-divider class="mr-8" inset vertical></v-divider>

        <v-menu :close-on-content-click="false" offset-y class="px-7">
          <template v-slot:activator="{ on, props }">
            <v-btn variant="elevated" color="primary" dark v-bind="props" v-on="on">
              Select Headers
            </v-btn>
          </template>
          <v-list style="max-height: 750px"
                  class="overflow-y-auto">
            <v-list-item
                v-for="(item, index) in data.defaultHeaders"
                :key="index"
                density="compact"
            >
              <v-row>
                <v-col cols="2">
                  <v-checkbox @change="changeHeaders" v-model="item.bool"></v-checkbox>
                </v-col>
                <v-col cols="10" class="mt-4">
                  <v-list-item-title class="ml-1" color="#000000">{{item.title}}</v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-menu>

      </v-toolbar>

      <v-row class="px-5" density="compact">
        <v-col cols="12" sm="3">
          <v-text-field clearable label="Name (Any Part)" v-model="data.nameModel"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-select clearable v-model="data.statusModel" label="Status" :items="['Active', 'Inactive', 'Not Set']"></v-select>
        </v-col>
        <v-col cols="12" sm="2">
          <v-checkbox v-model="data.firstcallModel" label="First Call"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2">
          <v-checkbox v-model="data.preferredModel" label="Preferred"></v-checkbox>
        </v-col>
        <v-col cols="12" sm="2">
          <v-checkbox v-model="data.catactiveModel" label="Cat. Active"></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="px-5" density="compact">
        <v-col cols="12" sm="3">
          <v-select clearable v-model="data.trainerModel" label="Trainer" :items="data.trainerItems"></v-select>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field clearable label="Loss State (Abbreviation)" v-model="data.stateModel"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field clearable label="Deployed State (Abbreviation)" v-model="data.deployedstateModel"></v-text-field>
        </v-col>
        <v-col cols="12" sm="3">
          <v-text-field clearable label="Licensed In State (Abbreviation)" v-model="data.licensestateModel"></v-text-field>
        </v-col>
      </v-row>

      <v-row class="px-5" density="compact">
        <v-col cols="12" sm="4">
          <v-text-field clearable label="Set Loss Location" v-model="data.losslocationModel"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select clearable v-model="data.certifications" label="Certifications" :items="data.certificationItems" multiple></v-select>
        </v-col>
        <v-col cols="12" sm="4">
          <v-checkbox v-model="data.hasAccountModel" label="Has User Account"></v-checkbox>
        </v-col>
      </v-row>

      <v-row class="px-5" density="compact">
        <v-col cols="12" sm="4">
          <v-text-field clearable label="NPN" v-model="data.npn"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-menu
              v-model="data.npnStartOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.npnDateStart"
              bottom
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.npnDateStart"
                  label="NPN From Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.npnDateStart = DateUtil.formatDate(data.date); data.npnStartOpen = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="4">
          <v-menu
              v-model="data.npnEndOpen"
              :close-on-content-click="false"
              transition="scale-transition"
              :return-value="data.npnDateEnd"
              bottom
              max-width="290px"
              min-width="auto"
          >
            <template v-slot:activator="{ on, props }">
              <v-text-field
                  v-model="data.npnDateEnd"
                  label="NPN To Date"
                  v-bind="props"
                  v-on="on"
                  clearable
                  readonly
                  prepend-inner-icon="mdi-calendar"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="data.date"
                no-title
                :show-current="true"
                @update:modelValue="data.date=$event; data.npnDateEnd = DateUtil.formatDate(data.date); data.npnStartOpen = false;"
            ></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>

      <v-row class="px-5">
        <v-col align="center">
          <v-btn  @click="refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })" color="primary">
            Search People
          </v-btn>
        </v-col>
      </v-row>

      <v-data-table-server
          :search='data.searchRefresh'
          :headers="data.headers"
          :items="data.people"
          :items-length="data.totalPeople"
          :loading="data.dataLoading"
          class="elevation-1"
          loading-text="Loading... Please wait"
          :items-per-page-options="[5, 10, 15, 30, 50, 100, 500, 1000, 2000]"

          :page="data.options.page"
          @update:page="updatePage"
          :items-per-page="data.options.itemsPerPage"
          @update:itemsPerPage="updateItemsPerPage"
          :sortBy="data.options.sortBy"
          @update:sortBy="updateSortBy"
      >
<!--        <template v-slot:item="{ item }">-->
<!--          <tr>-->
<!--            <td>-->
<!--              <RouterLink :to="`/userprofile/${item.personid}`">-->
<!--                {{ item.name }} -->
<!--              </RouterLink>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span v-if="item.deployedstreetaddress !== 'undefined' && item.deployedstreetaddress !== 'null'"> {{item.deployedstreetaddress}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span v-if="item.deployedzip !== '0' && item.deployedzip !== 'null'"> {{item.deployedzip}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span v-if="item.deployedstate !== '0' && item.deployedstate !== 'null'"> {{item.deployedstate}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span v-if="item.deployedcity !== '0' && item.deployedcity !== 'null'"> {{item.deployedcity}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span v-if="item.shortcomment !== '0' && item.shortcomment !== 'null'"> {{item.shortcomment}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span> {{item.firstcall === true ? 'Yes' : 'No'}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span> {{item.preferred === 't' ? 'Yes' : 'No'}}</span>-->
<!--            </td>-->
<!--            <td>-->
<!--              <span> {{item.catactive === true ? 'Yes' : 'No'}}</span>-->
<!--            </td>-->
<!--          </tr>-->
<!--        </template>-->

        <template v-slot:[`item.name`]="{ item }">
          <RouterLink :to="`/userprofile/${item.personid}`">
            {{ item.name }}
          </RouterLink>
        </template>
        <template v-slot:[`item.deployedstreetaddress`]="{ item }">
          <span v-if="item.deployedstreetaddress !== 'undefined' && item.deployedstreetaddress !== 'null'"> {{item.deployedstreetaddress}}</span>
        </template>
        <template v-slot:[`item.deployedzip`]="{ item }">
          <span v-if="item.deployedzip !== '0' && item.deployedzip !== 'null'"> {{item.deployedzip}}</span>
        </template>
        <template v-slot:[`item.deployedstate`]="{ item }">
          <span v-if="item.deployedstate !== '0' && item.deployedstate !== 'null'"> {{item.deployedstate}}</span>
        </template>
        <template v-slot:[`item.deployedcity`]="{ item }">
          <span v-if="item.deployedcity !== '0' && item.deployedcity !== 'null'"> {{item.deployedcity}}</span>
        </template>
        <template v-slot:[`item.shortcomment`]="{ item }">
          <span v-if="item.shortcomment !== '0' && item.shortcomment !== 'null'"> {{item.shortcomment}}</span>
        </template>
        <template v-slot:[`item.firstcall`]="{ item }">
          <span> {{item.firstcall === true ? 'Yes' : 'No'}}</span>
        </template>
        <template v-slot:[`item.preferred`]="{ item }">
          <span> {{item.preferred === 't' ? 'Yes' : 'No'}}</span>
        </template>
        <template v-slot:[`item.catactive`]="{ item }">
          <span> {{item.catactive === true ? 'Yes' : 'No'}}</span>
        </template>
        <template v-slot:[`item.roles`]="{ item }">
          <v-chip
              v-if="item.is_admin === true"
              prepend-icon="mdi-star"
              class="ma-1"
              size="small"
              color="green"
          >
            AD Admin
          </v-chip>
          <template v-for="role in item.roles" :key="role">
            <v-chip
                class="ma-1"
                size="small"
                color="blue"
            >
              {{ role }}
            </v-chip>
          </template>
        </template>
        <template v-slot:[`item.hasaccount`]="{ item }">
          <v-icon v-if="item.hasaccount"> mdi-check </v-icon>
          <v-icon v-if="!item.hasaccount && Permissions.checkPermissions(['users.create'])" class="mr-2" @click="createUserFromPerson(item)"> mdi-plus </v-icon>
        </template>
        <template v-slot:[`item.npn`]="{ item }">
          <span> {{item.npn}}</span>
        </template>
        <template v-slot:[`item.npn_updated_on`]="{ item }">
          <span> {{displayTzDate(item.npn_updated_on)}}</span>
        </template>

      </v-data-table-server>
      <v-row class="px-10 mt-5">
        <v-col  cols='12' sm='6'>
          <!-- <v-text-field
            @update:modelValue="data.searchRequest=$event; searchMap()"
            label="Search Map"
            type="text"
            v-model="data.searchRequest"
            class="mx-2"
            v-if="showMap"
          >
          </v-text-field> -->
        </v-col>
        <v-col cols="12" sm="2">
          <div class="mx-2">
            <v-btn
                v-if="!data.clustering && data.showMap"
                @click="data.clustering=true; refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })"
                color="primary"
                dark
            >
              Cluster
            </v-btn>
            <v-btn
                v-if="data.clustering && data.showMap"
                @click="data.clustering=false; refresh({
                page: data.options.page,
                itemsPerPage: data.options.itemsPerPage,
                sortBy: data.options.sortBy
              })"
                class="mx-2"
                color="error"
                dark
            >
              Stop Clustering
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" sm="2">
          <div class="mx-2">
            <v-menu
                v-if="data.showMap"
                :close-on-content-click="false"
                offset-y
            >
              <template v-slot:activator="{ on, props }">
                <v-btn color="primary" dark v-bind="props" v-on="on">
                  Popup Info.
                </v-btn>
              </template>
              <v-list style="max-height: 750px"
                      class="overflow-y-auto">
                <v-list-item
                    v-for="(item, index) in data.popupHeaders"
                    :key="index"
                >

                  <v-checkbox @change="createMapMarkers(data.geodata, 'people')" v-model="item.bool" :label="item.title"></v-checkbox>
<!--                  <v-list-item-title>{{item.title}}</v-list-item-title>-->
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

        </v-col>
        <v-col cols='12' sm='2'>
          <v-btn
              v-if="data.showMap"
              class="grey lighten-2 ml-2"
              size="x-small"
              variant="elevated"
              @click="data.showMap = false; hideMap(false);"
          >
            <v-icon left size="x-small">mdi-window-close</v-icon>
            No Map
          </v-btn>
          <v-btn
              v-if="!data.showMap"
              class="grey lighten-2 ml-2"
              size="x-small"
              variant="elevated"
              @click="data.showMap = true; hideMap(true);"
          >
            <v-icon left size="x-small">mdi-plus</v-icon>
            Show Map
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center">
        <v-col align="center">
          <div id="map"></div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<style scoped>
[v-cloak] {
  display: none;
}
</style>